module.exports = __webpack_public_path__ + "static/media/plus.dcd27f70.png";